import React, {useState, useEffect, Fragment} from 'react'
import { Table, Label } from 'semantic-ui-react'

import _ from 'lodash';

export function Results(props){

    let customFields = _.reject(Object.keys(props.results), (key) => (key === 'parts' || key === 'final-result'));

    return (
        <Fragment>
            <h2>Ergebnisse</h2>

            <Table basic='very' celled collapsing>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>
                            
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            final-result
                        </Table.HeaderCell>
                        {
                            (typeof props.results.parts !== 'undefined')?
                                props.results.parts.map((part, idx) => (
                                    <Table.HeaderCell>
                                        {
                                            (typeof part.overtime !== 'undefined' && part.overtime)?
                                                'O'
                                            :
                                                (typeof part.shootout !== 'undefined' && part.shootout)?
                                                    'S'
                                                :
                                                    'P'
                                        }
                                        {idx + 1}
                                    </Table.HeaderCell>
                                ))
                            :null
                        }
                        {
                            customFields.map((key) => (
                                <Table.HeaderCell>{key}</Table.HeaderCell>
                            ))
                        }
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        props.event.teams.map((team, idx) => (
                            <Table.Row>
                                <Table.Cell>{team.name}</Table.Cell>
                                <Table.Cell>{(typeof props.results['final-result'] !== 'undefined')?props.results['final-result'][idx]:'-'}</Table.Cell>
                                {
                                    (typeof props.results.parts !== 'undefined')?
                                        props.results.parts.map((part) => (
                                            <Table.Cell>
                                                {part.result[idx]}
                                            </Table.Cell>
                                        ))
                                    :null
                                }
                                {
                                    customFields.map((key) => (
                                        Array.isArray(props.results[key])?
                                            <Table.Cell>{(typeof props.results[key][idx] === 'boolean')?(props.results[key][idx]?'true':'false'):props.results[key][idx]}</Table.Cell>
                                        :
                                            (idx === 0)?
                                                <Table.Cell rowspan={props.event.teams.length}>{(typeof props.results[key] === 'boolean')?(props.results[key]?'true':'false'):props.results[key]}</Table.Cell>
                                            :null
                                    ))
                                }
                            </Table.Row>
                        ))
                    }
                </Table.Body>
            </Table>
        </Fragment> 
    )
}